function relocateCurrencyDropdown() {
    const parent = document.querySelector('.lang-and-currency-wrap');
    const dropdown = document.querySelector('.currency-converter-chooser');
    const trigger = document.querySelector('.currency-converter-currency-button');

    if (parent && dropdown && trigger) {
        // 1. Move the UL inside the wrap div
        parent.appendChild(dropdown);
        
        // --- UPDATED: Text Logic ---
        const listItems = dropdown.querySelectorAll('.currency-converter-chooser-item span');
        listItems.forEach(span => {
            const originalText = span.innerText.trim();

            // Handle "Autodetect currency" case
            if (originalText.toLowerCase().includes("autodetect")) {
                span.innerText = "Auto";
            } 
            // Handle currency codes: "Bahraini Dinar (BHD)" -> "(BHD)"
            else {
                const match = originalText.match(/\(([^)]+)\)/);
                if (match) {
                    span.innerText = `(${match[1]})`;
                }
            }
        });
        // ---------------------------
        
        // 2. Clear out the app's conflicting inline styles
        dropdown.style.setProperty('position', 'absolute', 'important');
        dropdown.style.setProperty('top', '0%', 'important');
        dropdown.style.setProperty('left', '0', 'important');
        dropdown.style.setProperty('margin', '5px 0 0 0', 'important');
        dropdown.style.setProperty('width', 'auto', 'important');
        dropdown.style.setProperty('min-width', '90px', 'important');
        dropdown.style.setProperty('z-index', '999999', 'important');

        // 3. Toggle visibility on click
        trigger.onclick = function(e) {
            e.stopPropagation();
            const isHidden = window.getComputedStyle(dropdown).display === 'none' || dropdown.style.opacity === '0';
            dropdown.style.setProperty('display', isHidden ? 'block' : 'none', 'important');
            dropdown.style.setProperty('opacity', isHidden ? '1' : '0', 'important');
        };

        // Close if clicking outside
        document.addEventListener('click', (e) => {
            if (!parent.contains(e.target)) {
                dropdown.style.setProperty('display', 'none', 'important');
                dropdown.style.setProperty('opacity', '0', 'important');
            }
        });
        
        console.log("Currency dropdown updated: Auto and (Codes) applied.");
    }
}

// Run once on load, and again after a short delay
window.addEventListener('load', relocateCurrencyDropdown);
setTimeout(relocateCurrencyDropdown, 2000);
